const br = {
  table: {
    actions: "Ações",
  },
  errors: {
    requiredFieldsEmpty: "Existem campos obrigatórios vazios",
    fieldRequired: "Campo Obrigatório",
  },
  done: "Feito",
  print: "Imprimir",
  login: "Entrar",
  username: "Usuário",
  password: "Senha",
  customFields: "Campos Custom.",
  variables: "Variáveis",
  edit: "Editar",
  general: "Geral",
  delete: "Excluir",
  save: "Salvar",
  confirm: "Confirmar",
  warning: "Atenção",
  cancel: "Cancelar",
  hours: "Horas",
  minutes: "Minutos",
  logout: "Sair",
  options: "Opções",
  height: "Altura",
  titleModalConfigFields: "Configurações de Campos",
  titleModalConfigFieldsColumnOne: "Campos do Job",
  titleModalConfigFieldsColumnTwo: "Campos do Tipo de registro Selecionado",
  dayOfWeek: {
    sunday: "Domingo",
    monday: "Segunda",
    tuesday: "Terça",
    wednesday: "Quarta",
    thursday: "Quinta",
    friday: "Sexta",
    saturday: "Sabado",
  },
  analyzeInput: { title: "Análises", group: "Grupo | Grupos" },
  components: {
    basicHistory: {
      createAt: "Incluído em",
      createBy: "por",
    },
    regEdit: {
      filters: {
        jobCode: "Código Job",
        resourceCode: "Código Recurso ",
        regTypeCode: "Código Tipo de Registro ",
        user: "Usuário",
        dtStart: "Data Inicio",
        dtEnd: "Data Fim",
        searchEdit: "Pesquisar",
      },
      headers: {
        date: "Data",
        regType: "Tipo de Registro",
        job: "Código Job",
        description: "Descrição Job",
        resource: "Recurso",
        codAccount: "Código Conta",
        desAccount: "Descrição Conta",
        codItem: "Código Item",
        descItem: "Descrição Item",
        user: "Usuário",
        isIntegrated: "Integrado",
      },
      fields: {
        fieldTitle: "Campos",
        fieldDelete: "Deletar",
        fieldSubtitle: "Campo",
        valueSubtitle: "Valor",
        noFields: "Nenhum Campo",
      },
    },
  },

  entities: {
    reg: {
      production: "Produção",
      title: "Registro | Registros",
      props: {
        date: "Data | Data Retroativa"
      }
    },
    actionField: {
      title: "Campo | Campos",
      comboValue: "Valor",
      props: {
        label: "Nome do Campo",
        dataType: "Tipo do dado",
        isRequired: "Obrigatório",
        combo: "Combo",
      },
    },
    action: {
      title: "Ação | Ações",
      props: {
        code: "Código",
        description: "Descrição",
        path: "Caminho",
        type: "Tipo",
        group: "Grupo",
        entity: "Entidade",
        response: "Resposta",
        fields: "Campos"
      },
    },
    job: {
      title: "Job | Jobs",
      solic: "Solicitação de Job",
      props: {
        code: "Código",
        group: "Agrupar este Job?",
        description: "Descrição",
        status: "Status",
        date: "Data",
        environmentId: "Ambiente",
        item: "Item",
        qt: "Quantidade",
        version: "Versão",
        accountId: "Conta",
        deadline: "Deadline",
        notes: "Observação"
      },
      forms: {
        create: {
          title: "Criar Job",
        },
      },
    },
    jobStageItemCons: {
      title: "Item | Itens",
      props: {
        itemId: "Item Cadastrado",
        itemDescription: "Item Descrição",
        unitId: "Unidade",
        qtEstimated: "Qtd Estimada",
        qtReal: "Qtd Real",
      },
    },
    printer: {
      title: "Impressora | Impressoras",
      props: {
        code: "Código",
        description: "Descrição",
        path: "Caminho",
        printAgentPath: "Caminho Print Agent ",
      },
    },
    jobStageItemProd: {
      title: "Item | Itens",
      props: {
        itemId: "Item Cadastrado",
        itemDescription: "Item Descrição",
        unitId: "Unidade",
        qtEstimated: "Qtd Estimada",
        qtReal: "Qtd Real",
      },
    },
    jobStage: {
      title: "Jog Estágio | Job Estágios",
      tabs: {
        form: {
          jobStageItemsProd: "Items Prod",
          jobStageItemsCons: "Items Cons",
        },
      },
      props: {
        status: "Status",
        order: "Ordem",
        description: "Descrição",
        timeSetupEstimatedMin: "Setup Estimado (Min)",
        timeSetupRealMin: "Setup Real (Min)",
        timeProdEstimatedMin: "Produção Estimada (Min)",
        timeProdRealMin: "Produção Real (Min)",
        qtLossEstimated: "Qtd Perda Estimada",
        qtLossReal: "Qtd Perda Real",
        percLoss: "% Perda Estimada",
        resourceId: "Recurso",
        stageTypeId: "Tipo de Estágio",
        versionId: "Versão",
        itemId: "Item",
        subStage: "Sub-estágio",
      },
    },
    stageType: {
      title: "Tipo de Estágio | Tipos de Estágio",
      tabs: {
        form: {
          regTypes: "Tipos de Registro",
        },
      },
      props: {
        description: "Descrição",
        name: "Nome",
        environmentId: "Ambiente",
      },
    },
    user: {
      title: "Usuário | Usuários",
      props: {
        code: "Código",
        name: "Nome",
      },
    },
    report: {
      title: "Relatório | Relatórios",
      props: {
        query: "Query",
        font: "Fonte",
        params: "Parâmetro | Parâmetros",
        description: "Descrição",
      },
    },
    resource: {
      title: "Recurso | Recursos",
      props: {
        code: "Código",
        seq: "Seq",
        environmentId: "Ambiente",
        description: "Descrição",
        resourceRestIds: "Recurso Compatível",
        stageTypeId: "Tipo de Estágio",
        printerId: "Impressora",
        sector: "Setor",
        type: "Tipo",
      },
    },
    entityFieldCustom: {
      title: 'Campo Custom. | Campos Custom.',
      props: {
        entity: 'Entidade',
        type: 'Tipo',
        group: 'Grupo',
        label: 'Campo',
        seq: "Seq"
      }
    },
    account: {
      title: "Conta | Contas",
      props: {
        code: "Código",
        name: "Nome",
      },
    },
    regTypeFields: {
      title: "Campo de Registro | Campos de Registro",
      props: {
        label: "Campo",
        seq: "Seq",
        typeData: "Tipo de Dado",
        behavior: "Comportamento",
        parameterItemId: "Item Parâmetro",
        length: "Limite de Caracteres",
        required: "Obrigatório",
        optionLabel: "Opção",
        readOnly: "Apenas Leitura",
        variableKey: "Nome da Variável",
        variableType: "Tipo da Variável",
        readType: "Tipo de Leitura"
      },
    },
    regType: {
      title: "Tipo de Registro | Tipos de Registro",

      props: {
        code: "Código",
        description: "Descrição",
        color: "Cor",
        keepFieldIds: "Manter Campos",
        continuous: "Continuo",
        allowRetroactive: "Permite Retroativo",
        retroactiveLimitDays: "Limite de Dias Retroativos",
        stageRequired: "Requer Estágio",
        environmentId: "Ambiente",
        jobStatusId: "Mudar para Job Status",
        jobStageStatusId: "Mudar para Job Estágio Status",
        reportId: "Relatório",
        printerId: "Impressora",
        timeType: 'Tempo',
        trigger: {
          title: 'Gatilho | Gatilhos',
          props: {
            confirm: 'Confirmação',
            beforeSend: 'Depois de Enviar',
            afterSend: 'Antes de Enviar'
          }
        },
      }
    },
    regEdit: {
      title: "Consulta de Registro | Consulta de Registros",
    },
    environment: {
      filter: "Setor",
      title: "Ambiente | Ambientes",
      calendarExc: {
        title: "Calendário Exc",
        props: {
          date: "Data",
          start: "Hora Inicial",
          end: "Hora Final",
        },
      },
      calendarProd: {
        title: "Calendário Prod",
        props: {
          dayOfWeek: "Dia da Semana",
          start: "Hora Inicial",
          end: "Hora Final",
        },
      },
      jobStageStatus: {
        title: "Job Estágio Status",
        props: {
          status: "Status",
          seq: "Seq",
          description: "Descrição",
          color: "Cor",
          statusNext: "Status Seguinte",
          type: "Tipo",
        },
      },
      jobStatus: {
        title: "Job Status",
        props: {
          status: "Status",
          seq: "Seq",
          description: "Descrição",
          color: "Cor",
          statusNext: "Status Seguinte",
          leadTimeMin: "Lead Time (min)",
        },
      },
      tabs: {
        form: {
          jobStatus: "Job Status",
          jobStageStatus: "Job Estágio Status",
          calendarProd: "Calendário Prod",
          calendarExc: "Calendário Exc",
        },
      },
      props: {
        code: "Código",
        description: "Descrição",
      },
    },
    stageItem: {
      title: "Item | Itens",
      itemDatabase: "Item existente",
      props: {
        itemId: "Item Cadastrado",
        itemDescription: "Item Descrição",
        unitId: "Unidade",
        qt: "Quantidade",
        qtMin: "Quantidade Min",
        qtMax: "Quantidade Max",
        qtIdeal: "Quantidade ideal",
      },
    },
    stage: {
      title: "Estágio | Estágios",
      tabs: {
        form: {
          stageItemsProd: "Itens Prod",
          stageItemsCons: "Itens Cons",
        },
      },
      props: {
        description: "Descrição",
        seq: "Sequência",
        timeSetupEstimatedMin: "Setup Estimado (Min)",
        timeProdEstimatedMin: "Produção Estimada (Min)",
        percLoss: "% Perda Estimada",
        resourceId: "Recurso",
        stageTypeId: "Tipo de Estágio",
        versionId: "Versão",
        itemId: "Item",
        subStage: "Sub-estágio",
      },
    },
    version: {
      title: "Versão | Versões",
      tabs: {
        form: {
          stages: "Estágios",
        },
      },
      props: {
        code: "Código",
        description: "Descrição",
        unit: "Unidade",
      },
    },
    item: {
      title: "Item | Itens",
      props: {
        code: "Código",
        environmentId: "Ambiente",
        description: "Descrição",
        unit: "Unidade",
        type: "Tipo",
      },
    },
    unit: {
      title: "Unidade | Unidades",
      props: {
        code: "Código",
        description: "Descrição",
        type: "Tipo",
      },
    },
  },
}


export default br;
